import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-record\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512S0 794.77 0 512 229.23 0 512 0z m1 204c-24.853 0-45 20.147-45 45v254c0 14.767 7.113 27.874 18.1 36.079a45.455 45.455 0 0 0 4.278 4.938l179.605 179.605c17.573 17.574 46.066 17.574 63.64 0 17.573-17.573 17.573-46.066 0-63.64L558 484.36V249c0-24.604-19.746-44.597-44.256-44.994z\" p-id=\"11917\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/record.svg
// module id = q1X2
// module chunks = 7